import { render, staticRenderFns } from "./MediaItemCard.vue?vue&type=template&id=533a9198&scoped=true&"
import script from "./MediaItemCard.vue?vue&type=script&lang=ts&"
export * from "./MediaItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./MediaItemCard.vue?vue&type=style&index=0&id=533a9198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a9198",
  null
  
)

export default component.exports